/**
 * Compatibility layer for existing imports.
 * The webpack entry point is main.js. Scenes that need the Phaser config
 * can keep importing from here.
 */
import getConfig from '@config/baseConfig';

const config = getConfig();

export { config };

// NOTE: Game instantiation is handled by main.js → baseInitializer.js.
